import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Row } from "antd";
import { FilePdfFilled } from "@ant-design/icons";

export const VisualizarDocumentoHTML: React.FC<{
    html: string,
    onExport?:() => void;
    isLoadingExport?:boolean;
}> = (props) => {
    const iframeRef = useRef<HTMLIFrameElement>(null)

    const [ iframeHeight, setIframeHeight ] = useState<number | undefined>(iframeRef.current?.contentDocument?.querySelector("body")?.clientHeight)

    useEffect(() => {
        setTimeout(() => {
            /* Espera o suficiente para esperar o React renerizar e configura o valor da altura corretamente. */
            setIframeHeight(iframeRef.current?.contentDocument?.querySelector("body")?.clientHeight)
        }, 10)
    }, [iframeRef, props.html])

    useEffect(() => {
        const vdoc = iframeRef.current?.contentWindow?.document;
        vdoc?.open();
        vdoc?.write(props.html);
        vdoc?.close();
    }, [iframeRef, props.html]);

    const printIFrame = () => {
        iframeRef.current?.contentWindow?.print();
    }

    return (
        <React.Fragment>
            <style type="text/css" media="print"></style>

            <Row gutter={[0, 16]} style={{ margin: 8 }}>
                <Col xs={24} style={{ display: "flex", flexDirection: "row-reverse" }}>
                    <Button type="primary" icon={<FilePdfFilled />} loading={props?.isLoadingExport ?? false} onClick={props?.onExport ?? printIFrame}>
                        Exportar
                    </Button>
                </Col>

                <Col xs={24}>
                    <Card style={{ backgroundColor : "#fff" }}>
                        <iframe
                            style={{ border: "none", backgroundColor : "#fff" }}
                            width={"100%"}
                            height={iframeHeight}
                            ref={iframeRef}
                            src="about:blank"
                        ></iframe>

                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
}